import { Grid, Skeleton, Box } from '@mui/material'
import { CardSkeleton } from '@/components/common'

interface ProductLoadingProps {
  itemCount?: number
  direction?: Direction
  showPagination?: boolean
}

export const ProductLoading = ({
  itemCount = 8,
  direction = 'GRID',
  showPagination = true,
}: ProductLoadingProps) => {
  return (
    <>
      <Grid container spacing={{ xs: 1, md: 2 }} columns={24}>
        {[...Array(itemCount)].map((_, index) => (
          <Grid
            size={
              direction !== 'GRID'
                ? 24
                : {
                    xs: 12,
                    sm: 8,
                    lg: 6,
                  }
            }
            key={index}
          >
            <CardSkeleton />
          </Grid>
        ))}
      </Grid>

      {showPagination && (
        <Box sx={{ mx: 'auto', my: 4, display: 'flex', justifyContent: 'center' }}>
          <Skeleton variant="rectangular" width={300} height={40} />
        </Box>
      )}
    </>
  )
}
